"use client";

import { cn, Select, SelectItem, Typography } from "@kyan/ui";

import { OrderbookTable } from "#/components/OrderbookTable/OrderbookTable";

import { usePerpsOrderbookController } from "./PerpsOrderbook.controller";

export interface PerpsOrderbookProps {
  layerSize?: number;
  fullWidth?: boolean;
  isPerpPage?: boolean;
}

export const PerpsOrderbook: React.FC<PerpsOrderbookProps> = ({
  layerSize,
  fullWidth,
  isPerpPage = true,
}) => {
  const {
    tickSize,
    tickSizes,
    lastTrade,
    isLoading,
    perpsOrderbook,
    marketIndexPrice,
    handleSelectRow,
    handleSetTickSize,
    isOrderbookLoading,
  } = usePerpsOrderbookController();

  return (
    <div
      className={cn("flex flex-col gap-1.5", {
        "w-70 2xl:w-97.5": !fullWidth,
        "w-full": fullWidth,
        "gap-0": !isPerpPage,
      })}
    >
      <div
        className={cn("flex items-center justify-between pr-2 pl-1", {
          "border-divider border-b px-2 py-1": !isPerpPage,
        })}
      >
        <Typography grotesk primary size={12}>
          {`${fullWidth ? "Perp " : ""}Order Book`}
        </Typography>
        <div className="flex items-center gap-1">
          <Select
            variant="mini"
            triggerClassName="w-16"
            value={String(tickSize)}
            defaultValue={String(tickSize)}
            onValueChange={handleSetTickSize}
          >
            {tickSizes.map((value) => {
              return (
                <SelectItem key={value} value={String(value)}>
                  {value}
                </SelectItem>
              );
            })}
          </Select>
          <Typography size={10}>USD</Typography>
        </div>
      </div>

      <OrderbookTable
        variant="perps"
        lastTrade={lastTrade}
        layerSize={layerSize}
        isPerpPage={isPerpPage}
        buys={perpsOrderbook.buys}
        sells={perpsOrderbook.sells}
        indexPrice={marketIndexPrice}
        isLastTradesLoading={isLoading}
        price={perpsOrderbook.midPrice}
        isOrderbookLoading={isOrderbookLoading}
        onSelectRow={handleSelectRow}
      />
    </div>
  );
};
